import axios from 'axios'
import Vue from 'vue'
let baseurl = Vue.prototype.baseurl;//main.js中
let projectName = Vue.prototype.projectName;//main.js中
// console.log("request baseurl==", baseurl);
// 创建本地 axios 实例
const service = axios.create({
  baseURL: baseurl+projectName+"/front", // api base_url
  timeout: 20000000 // 请求超时时间
})
export {
  service as axios
}